import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { EERIE } from 'HubStyleTokens/colors';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIHelpLink from 'UIComponents/tooltip/UIHelpLink';
import { useTracker } from '../tracking/useTracker';
import styled from 'styled-components';
import { devices } from '../styles/viewports.styles';
import { StyledUILink } from './TextInput.styles';
const Tooltip = styled.span.withConfig({
  displayName: "TitleTooltip__Tooltip",
  componentId: "sc-13leqhc-0"
})(["display:none;@media ", "{display:inline;font-size:1rem;}"], devices.desktop);
const MobileLearnMore = styled.span.withConfig({
  displayName: "TitleTooltip__MobileLearnMore",
  componentId: "sc-13leqhc-1"
})(["font-size:1rem;@media ", "{display:none;}"], devices.desktop);
const LearnMoreLink = styled(UIHelpLink).withConfig({
  displayName: "TitleTooltip__LearnMoreLink",
  componentId: "sc-13leqhc-2"
})(["margin-left:5px;"]);
const TooltipWrapper = styled.div.withConfig({
  displayName: "TitleTooltip__TooltipWrapper",
  componentId: "sc-13leqhc-3"
})(["", ""], props => props.isMobile && `padding: 10px 0; `);
export const TitleTooltip = ({
  stepKey,
  tooltipLink
}) => {
  const Tracker = useTracker();

  const getTooltipText = (isMobile = false) => {
    return /*#__PURE__*/_jsx(TooltipWrapper, {
      isMobile: isMobile,
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `views.${stepKey}.tooltip`,
        options: {
          link: /*#__PURE__*/_jsx(StyledUILink, {
            external: true,
            onClick: () => {
              Tracker.signupInteraction('click-tooltip-link');
              window.open(tooltipLink, '_blank');
            },
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: `views.${stepKey}.tooltipLink`
            })
          }, "title-link")
        }
      })
    });
  };

  const trackOpen = () => {
    Tracker.signupInteraction('open-tooltip');
  };

  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(Tooltip, {
      children: /*#__PURE__*/_jsx(UIHelpIcon, {
        title: getTooltipText(),
        tooltipPlacement: "right",
        tooltipProps: {
          use: 'longform'
        }
      })
    }), /*#__PURE__*/_jsxs(MobileLearnMore, {
      children: [/*#__PURE__*/_jsx(UIIcon, {
        color: EERIE,
        name: "info"
      }), /*#__PURE__*/_jsx(LearnMoreLink // @ts-expect-error: style is not part of the FormattedHTMLMessage props
      , {
        content: {
          header: /*#__PURE__*/_jsx("div", {}),
          body: getTooltipText(true)
        },
        showCloseButton: true,
        onOpenChange: trackOpen,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `views.${stepKey}.learnMore` // @ts-expect-error: style is not part of the FormattedHTMLMessage props
          ,
          style: {
            fontSize: '1rem'
          }
        })
      })]
    })]
  });
};